module.exports = __webpack_public_path__ + "static/media/CHAP00-ENCADRE-FORTNITE.c2656ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP00-ENCADRE-FORTNITE.png
// module id = 274
// module chunks = 0